import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { updateProductApiV1ProductsOrgIdProductsProductIdPut } from '@/common/api/client/sdk.gen'
import { useCurrentOrg } from '@/app/entities/org/model'

const updateProductBrand = async (org_id: string, product_id: string, brand_id: string | null) => {
    const res = await updateProductApiV1ProductsOrgIdProductsProductIdPut({
        path: { org_id, product_id },
        body: { brand_id },
    })
    return res.data!
}

export const useUpdateProductBrand = () => {
    const queryClient = useQueryClient()
    const { data: currentOrg } = useCurrentOrg()
    const { productId } = useParams()

    return useMutation({
        mutationFn: (brand_id: string | null) => updateProductBrand(currentOrg?.id ?? '', productId ?? '', brand_id),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ['product', currentOrg?.id, productId] })
            void queryClient.invalidateQueries({ queryKey: ['products-infinite'] })
        },
    })
}
